// Props that make a non-button element behave like one: focusable, and triggered by Enter or Space as well as by a
// click, so the keyboard reaches what the mouse does.
export const onActivate = (handler) => (event) => {
  if ((event.key === 'Enter') || (event.key === ' ')) {
    event.preventDefault();
    handler(event);
  }
};

export const activate = (handler) => ({
  role: 'button',
  tabIndex: 0,
  onClick: handler,
  onKeyDown: onActivate(handler),
});
